document.addEventListener('DOMContentLoaded', function () {

  // Override miniCart.open() to prevent automatic cart opening
  // This prevents cart from opening when renderContents() is called
  let allowCartOpen = false; // Flag to control when cart can open

  // Function to setup cart open prevention
  function setupCartOpenPrevention() {
    const miniCart = document.querySelector('mini-cart');
    if (miniCart && !miniCart._openOverridden) {
      miniCart._openOverridden = true;
      const originalOpen = miniCart.open.bind(miniCart);

      miniCart.open = function () {
        if (!allowCartOpen) {
          return;
        }
        return originalOpen();
      };

      console.log('Cart auto-open prevention enabled for miniCart');
    }
  }

  // Setup immediately if miniCart exists
  setupCartOpenPrevention();

  // Also setup when miniCart is added to DOM (in case it loads later)
  const observer = new MutationObserver(function (mutations) {
    setupCartOpenPrevention();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Expose function to allow cart opening for user actions
  window.allowCartToOpen = function () {
    allowCartOpen = true;
    setTimeout(() => {
      allowCartOpen = false;
    }, 2000); // Increased to 2 seconds to ensure renderContents can open it
  };

  // Allow cart to open when user clicks cart icon or any add to cart button
  document.addEventListener('click', function (e) {
    const target = e.target.closest('cart-drawer summary, .cart-drawer-container summary, .header__icon--cart, [data-action="cart"], button[name="add"], .product-form button[type="submit"], .join-button, [data-action="add-to-cart"], add-to-cart, product-form button[type="submit"]');
    if (target) {
      window.allowCartToOpen();
    }
  }, true); // Use capture phase to run before other handlers

  // Also listen for ajaxProduct:added event (fired when product added via AddToCart custom element)
  document.addEventListener('ajaxProduct:added', function () {
    if (window.allowCartToOpen) {
      window.allowCartToOpen();
    }
  });

  // Listen for cart:updated event from product-form (PDP pages)
  document.addEventListener('cart:updated', function () {
    // Check if this was triggered by a user action (add to cart button)
    // Allow cart to open if it was a user action
    const activeElement = document.activeElement;
    if (activeElement && (
      activeElement.closest('product-form') ||
      activeElement.closest('add-to-cart') ||
      activeElement.closest('button[name="add"]')
    )) {
      if (window.allowCartToOpen) {
        window.allowCartToOpen();
      }
    }
  });

  const isSubscriptionCustomer =
    window.customer &&
    window.customer.tags &&
    window.customer.tags.some(tag => tag === 'Subscription' || tag.startsWith('Subscription-'));

  if (isSubscriptionCustomer) {
    const regularPriceElements = document.querySelectorAll('.price__regular--with-border');
    regularPriceElements.forEach(element => {
      element.style.borderBottom = 'none';
      element.style.padding = '0px';
      element.style.display = 'none';
    });
    const salePriceBlocks = document.querySelectorAll('.price__sale');
    salePriceBlocks.forEach(block => {
      block.style.display = 'none';
    });
  }


  // Use global discount percentage
  const discountPercentage = window.discountPercentage || 10;

  // Check if on product detail page
  const isProductPage = window.location.pathname.includes('/products/');

  // Define product containers (adjust selector based on theme)
  const productContainers = isProductPage
    ? [document.querySelector('.product') || document.body]
    : document.querySelectorAll('.grid__item, .product-card, .product-grid-item, .sticky-cart__content-heading');


  if (productContainers.length === 0) {
    return;
  }

  // Process each product container
  productContainers.forEach((container, containerIndex) => {

    // Find price elements within this container
    const priceElements = container.querySelectorAll('.price-item--regular price-money bdi');

    if (priceElements.length === 0) {
      return;
    }

    // Collect valid prices to determine if there's a range
    const prices = [];
    priceElements.forEach((element, index) => {
      const priceText = element.textContent.trim();

      // Skip invalid price text
      if (!priceText || priceText === '' || priceText === 'Rs.') {
        return;
      }

      // Clean price text
      const cleanedPriceText = priceText.replace(/[^0-9.]/g, '').replace(/^(\.|,)+/, '');
      const price = parseFloat(cleanedPriceText);

      if (isNaN(price)) {
        return;
      }

      prices.push(price);
    });

    // Check if valid prices were found
    if (prices.length === 0) {
      return;
    }

    // Find the lowest price
    const lowestPrice = Math.min(...prices);

    // Determine if there's a price range (distinct prices)
    const hasPriceRange = prices.length > 1 && Math.min(...prices) !== Math.max(...prices);

    // Calculate offer price based on lowest price
    const discountAmount = lowestPrice * (discountPercentage / 100);
    const offerPrice = (lowestPrice - discountAmount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    // Create offer price element
    const offerPriceElement = document.createElement('p');
    offerPriceElement.className = 'offer-price-custom';
    offerPriceElement.style.color = '#fff';
    offerPriceElement.style.display = 'block';
    offerPriceElement.style.fontWeight = 'bold';
    offerPriceElement.style.margin = '0px';
    offerPriceElement.style.cursor = 'pointer';
    offerPriceElement.style.fontSize = isProductPage ? '22px' : '18px';
    offerPriceElement.style.fontFamily = 'Work Sans';


    // Add "From" prefix only if there's a price range
    const pricePrefix = hasPriceRange ? 'From ' : '';
    offerPriceElement.innerHTML = `${pricePrefix}₹ ${offerPrice} <span style="font-size: 14px;font-weight:normal">Member Price</span>`;

    // Create container for price layout
    const priceContainer = document.createElement('div');
    priceContainer.style.display = 'flex';
    priceContainer.style.alignItems = 'center';
    priceContainer.style.flexWrap = 'wrap';
    priceContainer.style.gap = '6px 10px';
    priceContainer.style.width = '100%';
    priceContainer.style.margin = '10px 0px';

    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      priceContainer.style.flexDirection = 'column';
      priceContainer.style.alignItems = 'flex-start';
    }


    // Add the offer price to container
    priceContainer.appendChild(offerPriceElement);

    // Only add "Join Membership and Save" on product detail pages
    if (isProductPage && !isSubscriptionCustomer) {
      // priceContainer.style.justifyContent = 'space-between';
      if (!isMobile) {
        priceContainer.style.justifyContent = 'space-between';
      }
      // Create the membership join element (only for PDP)
      const membershipJoinElement = document.createElement('span');
      membershipJoinElement.className = 'membership-join-text';
      membershipJoinElement.style.color = '#fff';
      membershipJoinElement.style.cursor = 'pointer';
      membershipJoinElement.style.fontSize = '12px';
      membershipJoinElement.style.fontFamily = 'Work Sans';
      membershipJoinElement.style.letterSpacing= 'normal';
      membershipJoinElement.style.fontWeight = '600';
      membershipJoinElement.style.textDecoration = 'underline';
      membershipJoinElement.style.transition = 'all 0.3s ease';
      membershipJoinElement.style.whiteSpace = 'nowrap';
      membershipJoinElement.textContent = 'Join Membership and Save';

      // Add hover effect for button
      membershipJoinElement.addEventListener('mouseenter', function () {
        // this.style.backgroundColor = '#fff';
        // this.style.color = '#000';
      });

      membershipJoinElement.addEventListener('mouseleave', function () {
        this.style.backgroundColor = 'transparent';
        this.style.color = '#fff';
      });

      // Add click event listener for PDP quick view
      membershipJoinElement.addEventListener('click', function () {
        // Try with a delay to handle dynamically loaded elements

        // Get current product details from PDP
        const currentProductForm = document.querySelector('form[action*="/cart/add"]');
        let currentProductData = null;

        if (currentProductForm) {
          const formData = new FormData(currentProductForm);
          currentProductData = {
            id: formData.get('id'),
            quantity: formData.get('quantity') || 1,
            properties: {}
          };

          // Get any product properties
          for (let [key, value] of formData.entries()) {
            if (key.startsWith('properties[')) {
              currentProductData.properties[key] = value;
            }
          }
        }

        const waitForQuickView = () =>
          new Promise((resolve) => {
            const poll = () => {
              const quickViewSummary = document.querySelector('.quick-view__summary');
              const quickView = document.querySelector('quick-view');
              if (quickViewSummary || quickView) {
                resolve({ quickViewSummary, quickView });
              } else {
                requestAnimationFrame(poll);
              }
            };
            poll();
          });

        waitForQuickView().then(({ quickViewSummary, quickView }) => {
          const targetProductUrl = '/products/subscription-product';
          let quickViewElement = quickView;
          if (quickViewElement) {
            quickViewElement.setAttribute('data-product-url', targetProductUrl);
            quickViewElement.setAttribute('data-subscription-view', 'true');
          } else {
            const altQuickView = document.querySelector('.quick-view, [data-product-url]');
            if (altQuickView) {
              altQuickView.setAttribute('data-product-url', targetProductUrl);
              altQuickView.setAttribute('data-subscription-view', 'true');
              quickViewElement = altQuickView;
            } else {
              console.log('Offer Price Script: No alternative quick view element found');
            }
          }

          if (quickViewSummary) {
            quickViewSummary.click();
            setTimeout(() => {
              modifyQuickViewAddToCart(currentProductData);
            }, 1500);
          }
        });
      });

      // Create a wrapper to stack "Join Membership and Save" and "Already a member?" vertically
      const membershipWrapper = document.createElement('div');
      membershipWrapper.className = 'membership-actions-wrapper';
      membershipWrapper.style.display = 'flex';
      membershipWrapper.style.flexDirection = 'column';
      membershipWrapper.style.alignItems = isMobile ? 'flex-start' : 'flex-end';
      membershipWrapper.style.gap = '4px';
      membershipWrapper.style.marginLeft = isMobile ? '0' : 'auto';

      // Add "Join Membership and Save" to wrapper
      membershipWrapper.appendChild(membershipJoinElement);

      // Add "Already a member? Sign in" link for non-logged-in users
      if (!window.customer) {
        const signInLink = document.createElement('a');
        signInLink.href = '/account/login';
        signInLink.className = 'membership-signin-link';
        signInLink.style.fontSize = '12px';
        signInLink.style.fontFamily = 'Work Sans';
        signInLink.style.color = '#fff';
        signInLink.style.letterSpacing= 'normal';
        signInLink.style.textDecoration = 'none';
        signInLink.style.transition = 'color 0.3s ease';
        signInLink.style.whiteSpace = 'nowrap';
        signInLink.innerHTML = 'Already a member? <span style="font-weight:600;text-decoration:underline;">Sign in</span>';

        signInLink.addEventListener('mouseenter', function () {
          this.style.color = '#fff';
        });
        signInLink.addEventListener('mouseleave', function () {
          this.style.color = '#fff';
        });

        membershipWrapper.appendChild(signInLink);
      }

      // Append membership wrapper to container (only for PDP)
      priceContainer.appendChild(membershipWrapper);
    }

    // Append to parent (use the price container within this product)
    const parentContainer = priceElements[0].closest('.price');
    if (parentContainer) {
      // Check if offer price already exists to prevent duplicates
      if (!parentContainer.querySelector('.offer-price-custom')) {
        parentContainer.appendChild(priceContainer);
      } else {
        console.log(`Offer Price Script: Container ${containerIndex + 1}, Offer price already exists, skipping append`);
      }
    } else {
      console.log(`Offer Price Script: Container ${containerIndex + 1}, Parent (.price) not found`);
    }

    // Mark all price elements as processed
    priceElements.forEach((element) => {
      element.dataset.offerPriceApplied = 'true';
    });
  });

  // ========== JOIN NOW BUTTON - Add Subscription Product to Cart ==========
  // Handles "Join Now" buttons on membership pages (/pages/member-benefits)
  (function initJoinNowButtons() {
    // Select all potential "Join Now" buttons:
    // 1. Banner buttons (rendered by image-banner section) - <a> tags with text "Join now"
    // 2. .join-button elements (from membership popover template)
    const joinNowButtons = [];

    // Find all "Join now" links across the page (banner, customizer-added sections, etc.)
    // Using broad 'a' selector since customizer buttons have dynamic class names
    document.querySelectorAll('a').forEach(function (btn) {
      if (btn.textContent.trim().toLowerCase() === 'join now') {
        joinNowButtons.push(btn);
      }
    });

    // Also find .join-button elements
    document.querySelectorAll('.join-button').forEach(function (btn) {
      // Only add if not already handled by modifyQuickViewAddToCart (quick-view context)
      if (!btn.closest('.quick-view')) {
        joinNowButtons.push(btn);
      }
    });

    if (joinNowButtons.length === 0) {
      return;
    }


    joinNowButtons.forEach(function (btn) {
      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();

        const originalText = btn.textContent.trim();
        btn.textContent = 'Adding to Cart...';
        btn.style.pointerEvents = 'none';

        try {
          // Step 1: Check if subscription product is already in cart
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          const subscriptionInCart = cart.items.some(function (item) {
            return item.handle === 'subscription-product' ||
              (item.product_title && item.product_title.toLowerCase().includes('subscription')) ||
              (item.product_title && item.product_title.toLowerCase().includes('membership'));
          });

          if (subscriptionInCart) {
            // Product already in cart - show alert that goes away after 3 seconds
            showJoinNowAlert('Product is already in your cart');
            btn.textContent = originalText;
            btn.style.pointerEvents = '';
            return;
          }

          // Step 2: Fetch the subscription product to get variant ID
          const productResponse = await fetch('/products/subscription-product.js');
          const productData = await productResponse.json();

          if (!productData || !productData.variants || productData.variants.length === 0) {
            console.error('Subscription product not found or has no variants');
            btn.textContent = originalText;
            btn.style.pointerEvents = '';
            return;
          }

          const variantId = productData.variants[0].id;

          // Step 3: Add to cart
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1
              }]
            })
          });

          const addData = await addResponse.json();

          if (addData.status && addData.status === 422) {
            console.error('Error adding subscription product:', addData.message);
            btn.textContent = originalText;
            btn.style.pointerEvents = '';
            return;
          }

          // Step 4: Allow cart to open and refresh mini-cart, then open drawer directly
          if (window.allowCartToOpen) {
            window.allowCartToOpen();
          }

          // Directly fetch cart sections and open the drawer
          try {
            const sectionsResponse = await fetch('/cart?sections=mini-cart,cart-icon-bubble');
            const sections = await sectionsResponse.json();

            // Update mini-cart contents
            const miniCartEl = document.getElementById('mini-cart');
            if (miniCartEl && sections['mini-cart']) {
              const parser = new DOMParser();
              const parsed = parser.parseFromString(sections['mini-cart'], 'text/html');
              const newContent = parsed.querySelector('.shopify-section');
              if (newContent) {
                miniCartEl.innerHTML = newContent.innerHTML;
              }
            }

            // Update cart icon bubble
            if (sections['cart-icon-bubble']) {
              const parser = new DOMParser();
              const parsed = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
              const newBubble = parsed.querySelector('.shopify-section');
              const currentBubble = document.getElementById('cart-icon-bubble');
              if (newBubble && currentBubble) {
                currentBubble.innerHTML = newBubble.innerHTML;
              }
            }

            // Directly open the cart drawer
            if (window.allowCartToOpen) {
              window.allowCartToOpen();
            }
            const cartDrawerEl = document.querySelector('cart-drawer');
            if (cartDrawerEl && typeof cartDrawerEl.openMenuDrawer === 'function') {
              cartDrawerEl.openMenuDrawer();
            } else {
              // Fallback: click the cart icon summary to open drawer
              const cartSummary = document.querySelector('cart-drawer details summary');
              if (cartSummary) {
                cartSummary.click();
              }
            }
          } catch (sectionsError) {
            console.error('Error opening cart drawer:', sectionsError);
            // Fallback: redirect to cart page
            window.location.href = '/cart';
          }


        } catch (error) {
          console.error('Error in Join Now handler:', error);
        } finally {
          btn.textContent = originalText;
          btn.style.pointerEvents = '';
        }
      });
    });

    function showJoinNowAlert(message) {
      // Remove any existing alert
      const existing = document.querySelector('.join-now-cart-alert');
      if (existing) existing.remove();

      const alert = document.createElement('div');
      alert.className = 'join-now-cart-alert';
      alert.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #1e1c36;
        color: #fff;
        padding: 15px 25px;
        border-radius: 8px;
        z-index: 10001;
        font-weight: 600;
        font-family: 'Work Sans', sans-serif;
        font-size: 14px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        transform: translateX(120%);
        transition: transform 0.3s ease;
        max-width: 350px;
        line-height: 1.4;
      `;
      alert.textContent = message;
      document.body.appendChild(alert);

      // Animate in
      setTimeout(function () {
        alert.style.transform = 'translateX(0)';
      }, 50);

      // Animate out after 3 seconds
      setTimeout(function () {
        alert.style.transform = 'translateX(120%)';
        setTimeout(function () {
          if (alert.parentNode) {
            alert.parentNode.removeChild(alert);
          }
        }, 300);
      }, 3000);
    }
  })();
  // ========== END JOIN NOW BUTTON ==========

  function modifyQuickViewAddToCart(currentProductData) {
    // Find the quick view add to cart button
    const quickViewAddToCart = document.querySelector('.quick-view form[action*="/cart/add"] button[type="submit"], .quick-view .btn[name="add"], .quick-view button[data-action="add-to-cart"], .join-button');
    // const quickViewAddToCart = document.querySelector('.quick-view form[action*="/cart/add"] button[type="submit"], .quick-view .btn[name="add"], .quick-view button[data-action="add-to-cart"]');
    setTimeout(() => {
      if (quickViewAddToCart) {

        quickViewAddToCart.addEventListener('click', function (e) {

          e.preventDefault();

          // Allow cart to open for this user action (Join Now button click)
          if (window.allowCartToOpen) {
            window.allowCartToOpen();
          }

          // Get membership product form data
          const membershipForm = this.closest('form');
          const membershipFormData = new FormData(membershipForm);

          const membershipProductData = {
            id: membershipFormData.get('id'),
            quantity: membershipFormData.get('quantity') || 1,
            properties: {},
            isSubscription: true // Mark this as subscription product
          };


          // Get membership product properties
          for (let [key, value] of membershipFormData.entries()) {
            if (key.startsWith('properties[')) {
              membershipProductData.properties[key] = value;
            }
          }

          // Add both products to cart
          addMultipleProductsToCart([currentProductData, membershipProductData]);
        });
      } else {
      }
    }, 300);

  }

  async function addMultipleProductsToCart(productsData) {
    // Filter out null products
    const validProducts = productsData.filter(product => product && product.id);

    if (validProducts.length === 0) {
      console.error('No valid products to add to cart');
      return;
    }

    // Show loading state
    const quickViewButton = document.querySelector('.quick-view form[action*="/cart/add"] button[type="submit"]');
    if (quickViewButton) {
      quickViewButton.disabled = true;
      quickViewButton.textContent = 'Adding to Cart...';
    }

    // Check cart first to prevent duplicate subscription products
    const subscriptionProductHandle = 'subscription-product';
    let subscriptionVariantIds = [];
    let subscriptionProductIds = [];
    let subscriptionSkipped = false;

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Check if subscription product is already in cart
      const subscriptionItems = cart.items.filter(item => {
        const isSubscription = item.product_handle === subscriptionProductHandle ||
          item.product_title && item.product_title.toLowerCase().includes('membership') ||
          item.product_title && item.product_title.toLowerCase().includes('subscription');
        return isSubscription;
      });


      // If subscription product is in cart, ensure quantity is 1 and collect variant IDs
      if (subscriptionItems.length > 0) {
        for (const item of subscriptionItems) {
          // Update quantity to 1 if it's more than 1
          if (item.quantity > 1) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                id: item.key,
                quantity: 1
              })
            });
          }

          // Collect variant IDs and product IDs to filter out
          subscriptionVariantIds.push(item.variant_id.toString());
          subscriptionVariantIds.push(item.variant_id); // Also add as number
          if (item.product_id) {
            subscriptionProductIds.push(item.product_id.toString());
            subscriptionProductIds.push(item.product_id);
          }
        }
      }
    } catch (error) {
      console.warn('Could not check cart, proceeding with normal add:', error);
    }

    // Filter out subscription product from items to add if it's already in cart
    const itemsToAdd = [];

    for (const product of validProducts) {
      const productVariantId = product.id.toString();
      const productVariantIdNum = parseInt(product.id);

      // Check if this product is marked as subscription
      const isMarkedSubscription = product.isSubscription === true;

      // Check if this is the subscription product by variant ID
      const isSubscriptionVariant = subscriptionVariantIds.includes(productVariantId) ||
        subscriptionVariantIds.includes(productVariantIdNum);

      // If subscription is in cart OR this product is marked as subscription, skip it
      const isSubscription = isMarkedSubscription || isSubscriptionVariant;

      if (isSubscription) {
        // If subscription is already in cart, skip adding it
        if (subscriptionVariantIds.length > 0) {
          subscriptionSkipped = true;
          // Don't add it - skip this product
        } else {
          // If not in cart, add it (first time)
          itemsToAdd.push({
            id: product.id,
            quantity: parseInt(product.quantity) || 1,
            properties: product.properties || {}
          });
        }
      } else {
        // Not a subscription product, add it normally
        itemsToAdd.push({
          id: product.id,
          quantity: parseInt(product.quantity) || 1,
          properties: product.properties || {}
        });
      }
    }


    // If no items to add (only subscription was in the list), show notification and return
    if (itemsToAdd.length === 0) {
      if (subscriptionSkipped) {
        showSubscriptionNotification('Membership subscription is already in your cart!');
      }
      updateCartNotification(0, false); // Don't open drawer for subscription skip
      if (quickViewButton) {
        quickViewButton.disabled = false;
        quickViewButton.textContent = 'Add to Cart';
      }
      return;
    }

    // If subscription was skipped but other products will be added, show notification
    if (subscriptionSkipped) {
      showSubscriptionNotification('Membership subscription is already in your cart. Adding other items...');
    }

    // Add to cart using Shopify Cart API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    })
      .then(response => response.json())
      .then(data => {
        handleCartResponse(data, itemsToAdd.length, quickViewButton);
      })
      .catch(error => {
        console.error('Error adding products to cart:', error);
        alert('Error adding products to cart: ' + error.message);
        if (quickViewButton) {
          quickViewButton.disabled = false;
          quickViewButton.textContent = 'Add to Cart';
        }
      });
  }

  function handleCartResponse(data, itemCount, quickViewButton) {
    if (data.status && data.status === 422) {
      throw new Error(data.message || 'Error adding products to cart');
    }

    // Close quick view
    const quickViewClose = document.querySelector('.quick-view .modal__close, .quick-view [data-action="close"]');
    if (quickViewClose) {
      quickViewClose.click();
    }

    //Update cart UI (if you have cart drawer/notification)
    // Only open drawer when user actually adds products (itemCount > 0)
    // Allow cart to open for this user action (adding product)
    if (itemCount > 0) {
      if (window.allowCartToOpen) {
        window.allowCartToOpen();
      }
      // Also allow opening for a longer period to ensure renderContents can open it
      setTimeout(() => {
        if (window.allowCartToOpen) {
          window.allowCartToOpen();
        }
      }, 100);
    }
    updateCartNotification(itemCount, itemCount > 0);

    // Reset button state
    if (quickViewButton) {
      quickViewButton.disabled = false;
      quickViewButton.textContent = 'Add to Cart';
    }
  }

  function updateCartNotification(itemCount, shouldOpenDrawer = false) {
    // If user added product (shouldOpenDrawer = true), allow cart to open
    // Otherwise, only update if cart is already open
    const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
    const isCartOpen = cartDrawer && (
      cartDrawer.hasAttribute('open') ||
      cartDrawer.classList.contains('active') ||
      cartDrawer.querySelector('details[open]')
    );

    // If cart is not open and we don't explicitly want to open it, don't do anything
    if (!shouldOpenDrawer && !isCartOpen) {
      // Don't fetch cart at all if drawer is closed and we don't want to open it
      // This prevents any cart operations that might trigger drawer opening
      console.log('Cart drawer closed - skipping cart update to prevent automatic opening');
      return;
    }

    // If shouldOpenDrawer is true, user just added product - allow cart to open
    if (shouldOpenDrawer) {
      console.log('User added product - allowing cart to open');
    }

    fetch('/cart.json')
      .then(response => response.json())
      .then(cart => {

        // Update cart count elements directly without opening drawer
        const cartCount = document.querySelector('cart-drawer .cart-count-bubble span[aria-hidden="true"]');
        const cartCountVisual = document.querySelector('cart-drawer .cart-count-bubble .visually-hidden');

        // Also check for cart count in header/mobile dock
        const allCartCounts = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count, [data-cart-count]');

        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }

        // Update all cart count elements found
        allCartCounts.forEach(el => {
          if (el) {
            el.textContent = cart.item_count;
          }
        });

        // Also update the visually hidden text for accessibility
        if (cartCountVisual) {
          cartCountVisual.textContent = `${cart.item_count} item${cart.item_count !== 1 ? 's' : ''}`;
        }

        // Only update cart sections and open drawer if explicitly requested (user added product)
        if (shouldOpenDrawer) {
          // Allow cart to open for this user action (user added product)
          if (window.allowCartToOpen) {
            window.allowCartToOpen();
          }

          // Trigger cart update event - this might open drawer in theme code, but it's intentional
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

          fetch('/cart?sections=mini-cart,cart-icon-bubble')
            .then((response) => response.json())
            .then((sections) => {
              const parsedState = {
                id: null,
                sections: {
                  'mini-cart': sections['mini-cart'],
                  'cart-icon-bubble': sections['cart-icon-bubble']
                }
              };

              // Refresh the mini-cart contents - allow opening since user action
              const miniCart = document.querySelector('mini-cart');
              if (miniCart && typeof miniCart.renderContents === 'function') {
                // Ensure cart can open for user action - call multiple times to be sure
                if (window.allowCartToOpen) {
                  window.allowCartToOpen();
                }
                // Call renderContents - it will call open() which is now controlled by our override
                miniCart.renderContents(parsedState);
              }

              // Update the cart bubble manually
              const newBubble = document.createElement('div');
              newBubble.innerHTML = sections['cart-icon-bubble'];
              const newCountBubble = newBubble.querySelector('.cart-count-bubble');
              const currentBubble = document.querySelector('.cart-count-bubble');
              if (newCountBubble && currentBubble) {
                currentBubble.replaceWith(newCountBubble);
              }
            })
            .catch((error) => {
              console.error('Error updating mini cart:', error);
            });
        } else {
          // Don't dispatch cart:updated event or call renderContents when we don't want drawer to open
          // Just silently update the cart count
        }

        // Show success notification
        // showSuccessNotification(`${itemCount} item${itemCount > 1 ? 's' : ''} added to cart!`);
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
        // Fallback: still show success message even if cart count update fails
        // showSuccessNotification(`${itemCount} item${itemCount > 1 ? 's' : ''} added to cart!`);
      });
  }

  function showSuccessNotification(message) {
    // Create or update notification
    let notification = document.querySelector('.cart-success-notification');
    if (!notification) {
      notification = document.createElement('div');
      notification.className = 'cart-success-notification';
      notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #28a745;
      color: white;
      padding: 15px 20px;
      border-radius: 5px;
      z-index: 10000;
      font-weight: 600;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      transform: translateX(100%);
      transition: transform 0.3s ease;
    `;
      document.body.appendChild(notification);
    }

    notification.textContent = message;

    // Animate in
    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
    }, 100);

    // Animate out
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }

  function showSubscriptionNotification(message) {
    // Create or update notification for subscription product
    let notification = document.querySelector('.subscription-cart-notification');
    if (!notification) {
      notification = document.createElement('div');
      notification.className = 'subscription-cart-notification';
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #1e1c36;
        color: #fff;
        padding: 15px 20px;
        border-radius: 5px;
        z-index: 10001;
        font-weight: 600;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        transform: translateX(100%);
        transition: transform 0.3s ease;
        max-width: 350px;
        line-height: 1.4;
      `;
      document.body.appendChild(notification);
    }

    notification.textContent = message;

    // Animate in
    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
    }, 100);

    // Animate out
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 4000);
  }

  /**
   * Hide "Join Membership and Save" buttons for subscription customers
   */
  function hideMembershipJoinButtons() {
    const membershipJoinElements = document.querySelectorAll('.membership-join-text');
    membershipJoinElements.forEach(element => {
      element.style.display = 'none';
    });
  }

  /**
   * Check if customer has subscription and remove membership product from cart if needed
   * This handles the case where user adds membership to cart while logged out, then logs in
   */
  async function checkAndRemoveSubscriptionFromCart(retryCount = 0, forceCheck = false) {

    // Only run if cart is already open OR if forceCheck is true (login, cart page, etc.)
    // This prevents automatic cart opening while still allowing removal on login
    if (!forceCheck) {
      const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
      const isCartOpen = cartDrawer && (
        cartDrawer.hasAttribute('open') ||
        cartDrawer.classList.contains('active') ||
        cartDrawer.querySelector('details[open]')
      );

      if (!isCartOpen) {
        console.log('Cart is not open, skipping check to prevent automatic opening');
        return; // Don't check if cart is not open - prevents automatic opening
      }
    }


    // Check if customer has subscription tags
    const isSubscriptionCustomer =
      window.customer &&
      window.customer.tags &&
      window.customer.tags.some(tag => tag === 'Subscription' || tag.startsWith('Subscription-'));


    // ULTRA-FAST: If customer data is available, proceed immediately - NO RETRIES
    // If customer data is NOT available, do ONE quick retry (100ms) then proceed anyway
    if (!window.customer) {
      if (retryCount === 0 && forceCheck) {
        // Only one quick retry if this is a forced check (login)
        setTimeout(() => {
          checkAndRemoveSubscriptionFromCart(1, forceCheck);
        }, 100);
        return;
      } else {
        // After retry or if not forced, proceed anyway - check cart directly
        // Proceed to check cart - we'll remove membership product if found
      }
    } else {
      // Customer data IS available - check immediately
      if (!isSubscriptionCustomer) {
        return; // Customer doesn't have subscription, no action needed
      }
      // Customer HAS subscription - proceed immediately to remove
      console.log('Customer has subscription - proceeding IMMEDIATELY to remove membership product');
    }

    try {
      // Fetch current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      if (!cart.items || cart.items.length === 0) {
        return; // Cart is empty
      }

      const subscriptionProductHandle = 'subscription-product';

      // Find subscription product items in cart - more comprehensive check
      const subscriptionItems = cart.items.filter(item => {
        const titleLower = item.product_title ? item.product_title.toLowerCase() : '';
        const handleLower = item.product_handle ? item.product_handle.toLowerCase() : '';
        const vendorLower = item.vendor ? item.vendor.toLowerCase() : '';
        const title = item.product_title || '';

        // Check for various subscription/membership indicators
        const isSubscription =
          item.product_handle === subscriptionProductHandle ||
          handleLower === 'subscription-product' ||
          handleLower.includes('subscription') ||
          handleLower.includes('membership') ||
          titleLower.includes('membership') ||
          titleLower.includes('subscription') ||
          titleLower.includes('justhuman membership') ||
          title === 'Justhuman Membership' ||
          vendorLower.includes('membership') ||
          vendorLower.includes('subscription');

        return isSubscription;
      });


      if (subscriptionItems.length === 0) {
        // Customer has subscription but no subscription product in cart
        // Just hide the "Join Membership and Save" button
        hideMembershipJoinButtons();
        return; // No subscription product in cart
      }

      // Remove all subscription items from cart

      const removePromises = subscriptionItems.map(async (item) => {
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          });
          const result = await response.json();
          return result;
        } catch (error) {
          console.error('Error removing item', item.product_title, ':', error);
          throw error;
        }
      });

      const removeResults = await Promise.all(removePromises);

      // Verify removal by checking cart again
      const verifyResponse = await fetch('/cart.js');
      const verifyCart = await verifyResponse.json();

      const remainingSubscriptionItems = verifyCart.items.filter(item => {
        const titleLower = item.product_title ? item.product_title.toLowerCase() : '';
        const handleLower = item.product_handle ? item.product_handle.toLowerCase() : '';
        const title = item.product_title || '';
        const isSubscription =
          item.product_handle === subscriptionProductHandle ||
          handleLower.includes('subscription') ||
          handleLower.includes('membership') ||
          titleLower.includes('membership') ||
          titleLower.includes('subscription') ||
          titleLower.includes('justhuman membership') ||
          title === 'Justhuman Membership';

        if (isSubscription) {
        }
        return isSubscription;
      });


      if (remainingSubscriptionItems.length > 0) {
        console.warn('Some subscription items still in cart, retrying removal...', remainingSubscriptionItems);
        // Retry removal with more aggressive approach
        const retryPromises = remainingSubscriptionItems.map(async (item) => {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          });
          const result = await response.json();
          return result;
        });
        await Promise.all(retryPromises);

        // Verify again after retry
        const finalVerify = await fetch('/cart.js');
        const finalCart = await finalVerify.json();
        const stillRemaining = finalCart.items.filter(item => {
          const titleLower = item.product_title ? item.product_title.toLowerCase() : '';
          return titleLower.includes('membership') || titleLower.includes('subscription') || item.product_title === 'Justhuman Membership';
        });
        if (stillRemaining.length > 0) {
          console.error('CRITICAL: Subscription items still in cart after retry:', stillRemaining);
        }
      }

      // Show notification
      showSubscriptionNotification('Membership subscription is already active. Removed from cart.');

      // Update cart UI silently without opening drawer
      // Check if cart drawer is already open - if so, refresh its contents
      const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
      const isCartOpen = cartDrawer && (
        cartDrawer.hasAttribute('open') ||
        cartDrawer.classList.contains('active') ||
        cartDrawer.querySelector('details[open]')
      );

      // Update cart count after removal (this won't open drawer)
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Update cart count elements directly without opening drawer
          const allCartCounts = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count, [data-cart-count]');
          allCartCounts.forEach(el => {
            if (el) {
              el.textContent = cart.item_count;
            }
          });

          // If cart drawer is open, refresh its contents without opening it
          if (isCartOpen) {
            const miniCart = document.querySelector('mini-cart');
            if (miniCart) {
              // Fetch cart sections and update innerHTML directly (like renderContents but without calling open)
              fetch('/cart?sections=mini-cart,cart-icon-bubble')
                .then((response) => response.json())
                .then((sections) => {
                  // Update mini-cart innerHTML directly without calling renderContents
                  const miniCartElement = document.getElementById('mini-cart');
                  if (miniCartElement && sections['mini-cart']) {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(sections['mini-cart'], 'text/html');
                    const sectionContent = doc.querySelector('.shopify-section');
                    if (sectionContent) {
                      miniCartElement.innerHTML = sectionContent.innerHTML;
                    }
                  }

                  // Update cart bubble
                  const newBubble = document.createElement('div');
                  newBubble.innerHTML = sections['cart-icon-bubble'];
                  const newCountBubble = newBubble.querySelector('.cart-count-bubble');
                  const currentBubble = document.querySelector('.cart-count-bubble');
                  if (newCountBubble && currentBubble) {
                    currentBubble.replaceWith(newCountBubble);
                  }
                })
                .catch((error) => {
                  console.error('Error refreshing cart drawer:', error);
                });
            }
          } else {
            // Cart drawer is closed - just update cart bubble
            fetch('/cart?sections=cart-icon-bubble')
              .then((response) => response.json())
              .then((sections) => {
                const newBubble = document.createElement('div');
                newBubble.innerHTML = sections['cart-icon-bubble'];
                const newCountBubble = newBubble.querySelector('.cart-count-bubble');
                const currentBubble = document.querySelector('.cart-count-bubble');
                if (newCountBubble && currentBubble) {
                  currentBubble.replaceWith(newCountBubble);
                }
              })
              .catch((error) => {
                console.error('Error updating cart bubble:', error);
              });
          }

        })
        .catch(error => {
          console.error('Error fetching cart after removal:', error);
        });

      // Hide "Join Membership and Save" button if it exists
      hideMembershipJoinButtons();

    } catch (error) {
      console.error('Error checking/removing subscription from cart:', error);
    }
  }

  /**
   * Check for login and handle subscription removal
   */
  function handleLoginCheck() {
    // Don't check on login/account pages - wait until user navigates away
    const isLoginPage = window.location.pathname.includes('/account/login') ||
      window.location.pathname.includes('/account/register') ||
      (window.location.pathname.includes('/account') && !window.location.pathname.includes('/account/orders'));

    if (isLoginPage) {
      return;
    }

    // Check sessionStorage for login flag
    // Don't clear it immediately - let post-registration-cart.js process it first
    // We'll clear it after a delay to allow subscription product to be added if needed
    const justLoggedIn = sessionStorage.getItem('justLoggedIn') === 'true';

    if (justLoggedIn) {
      // Don't clear the flag immediately - post-registration-cart.js needs it
      // Clear it after a delay to allow post-registration-cart.js to process it first
      setTimeout(() => {
        // Only clear if post-registration-cart.js hasn't already processed it
        // (it will clear the flag after adding subscription product)
        if (sessionStorage.getItem('justLoggedIn') === 'true') {
          sessionStorage.removeItem('justLoggedIn');
        }
      }, 5000); // Wait 5 seconds before clearing
      
      // Check cart IMMEDIATELY after login (forceCheck=true prevents cart opening)
      // Try multiple times with short delays to catch customer data as soon as it loads
      checkAndRemoveSubscriptionFromCart(0, true); // Immediate check
      setTimeout(() => {
        checkAndRemoveSubscriptionFromCart(0, true);
      }, 500); // 500ms check
      setTimeout(() => {
        checkAndRemoveSubscriptionFromCart(0, true);
      }, 1000); // 1s check
      setTimeout(() => {
        checkAndRemoveSubscriptionFromCart(0, true);
      }, 2000); // 2s check (backup)
    }

    // Also check URL for login redirect indicators (not on login page itself)
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('customer_posted') && !isLoginPage) {
      // Immediate check - customer data should be available
      checkAndRemoveSubscriptionFromCart(0, true);
      // One backup check after 200ms
      setTimeout(() => checkAndRemoveSubscriptionFromCart(0, true), 200);
    }
  }

  // Expose function globally for manual triggering if needed
  window.checkAndRemoveSubscriptionFromCart = checkAndRemoveSubscriptionFromCart;

  // Check and remove membership product when user navigates to account page
  function checkAccountPageForMembershipRemoval() {
    const isAccountPage = window.location.pathname.includes('/account') &&
      !window.location.pathname.includes('/account/login') &&
      !window.location.pathname.includes('/account/register');

    if (isAccountPage && window.customer) {
      const isSubscriptionCustomer = window.customer.tags &&
        window.customer.tags.some(tag => tag === 'Subscription' || tag.startsWith('Subscription-'));
      if (isSubscriptionCustomer) {
        checkAndRemoveSubscriptionFromCart(0, true);
      }
    }
  }

  // Check when page loads if on account page
  if (window.location.pathname.includes('/account') &&
    !window.location.pathname.includes('/account/login') &&
    !window.location.pathname.includes('/account/register')) {
    // Check immediately if customer data is available
    if (window.customer) {
      checkAccountPageForMembershipRemoval();
    } else {
      // Wait for customer data to load (should be immediate on account page)
      setTimeout(() => {
        checkAccountPageForMembershipRemoval();
      }, 200);
    }
  }

  // Also check when page becomes visible (backup check - only if login flag exists)
  // This is a backup in case immediate checks missed it
  let visibilityCheckDone = false;
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && window.customer && !visibilityCheckDone) {
      const isSubscriptionCustomer = window.customer.tags &&
        window.customer.tags.some(tag => tag === 'Subscription' || tag.startsWith('Subscription-'));
      // Only check if we just logged in (sessionStorage flag exists)
      const justLoggedIn = sessionStorage.getItem('justLoggedIn') === 'true';
      if (isSubscriptionCustomer && justLoggedIn) {
        visibilityCheckDone = true;
        sessionStorage.removeItem('justLoggedIn');
        checkAndRemoveSubscriptionFromCart(0, true);
      }
    }
  });

  // Helper function to check if we're on login/account pages
  function isLoginOrAccountPage() {
    return window.location.pathname.includes('/account/login') ||
      window.location.pathname.includes('/account/register') ||
      (window.location.pathname.includes('/account') && !window.location.pathname.includes('/account/orders'));
  }

  // Watch for window.customer to become available - ULTRA-FAST
  // Since customer data is available on login, check immediately
  if (sessionStorage.getItem('justLoggedIn') === 'true' || new URLSearchParams(window.location.search).has('customer_posted')) {
    // Check immediately - customer data should already be available on login
    if (window.customer) {
      const hasSubscription = window.customer.tags &&
        window.customer.tags.some(tag => tag === 'Subscription' || tag.startsWith('Subscription-'));
      if (hasSubscription) {
        checkAndRemoveSubscriptionFromCart(0, true);
      }
    }

    // Only ONE quick backup check (100ms) - customer data should be there
    setTimeout(() => {
      if (window.customer) {
        const hasSubscription = window.customer.tags &&
          window.customer.tags.some(tag => tag === 'Subscription' || tag.startsWith('Subscription-'));
        if (hasSubscription) {
          checkAndRemoveSubscriptionFromCart(0, true);
        }
      }
    }, 100); // Only 100ms backup check
  }

  // Don't run any cart checks on login/account pages to prevent cart opening
  if (!isLoginOrAccountPage()) {
    // Check on page load if user just logged in - but only hide buttons, don't check cart
    handleLoginCheck();

    // Also watch for customer data to become available (after login) - ULTRA-FAST
    // Since customer data is available on login, this should be immediate
    if (sessionStorage.getItem('justLoggedIn') === 'true' || new URLSearchParams(window.location.search).has('customer_posted')) {
      // Check immediately - no waiting
      if (window.customer) {
        const hasSubscription = window.customer.tags &&
          window.customer.tags.some(tag => tag === 'Subscription' || tag.startsWith('Subscription-'));
        if (hasSubscription) {
          checkAndRemoveSubscriptionFromCart(0, true);
        }
      }

      // Only 2 quick backup checks (200ms total max wait)
      let checkCount = 0;
      const quickCheck = setInterval(() => {
        checkCount++;
        if (window.customer) {
          const hasSubscription = window.customer.tags &&
            window.customer.tags.some(tag => tag === 'Subscription' || tag.startsWith('Subscription-'));
          if (hasSubscription) {
            clearInterval(quickCheck);
            checkAndRemoveSubscriptionFromCart(0, true);
          } else {
            clearInterval(quickCheck);
          }
        }
        // Stop after 2 checks (200ms)
        if (checkCount >= 2) {
          clearInterval(quickCheck);
        }
      }, 100); // Check every 100ms, max 2 times = 200ms total
    }

    // Also check on initial load if customer has subscription (hide buttons if needed)
    if (isSubscriptionCustomer) {
      hideMembershipJoinButtons();
      // Also check cart immediately if customer has subscription (they might have logged in)
      // Check immediately, no delay
      checkAndRemoveSubscriptionFromCart(0, true);
      // Also check after 200ms as backup
      setTimeout(() => {
        checkAndRemoveSubscriptionFromCart(0, true);
      }, 200);

      // Also check cart periodically if customer has subscription (in case login detection failed)
      let periodicCheckCount = 0;
      const periodicCheckInterval = setInterval(() => {
        periodicCheckCount++;

        if (window.customer) {
          const hasSubscription = window.customer.tags &&
            window.customer.tags.some(tag => tag === 'Subscription' || tag.startsWith('Subscription-'));
          if (hasSubscription) {
            // Check if cart is open
            const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
            const isCartOpen = cartDrawer && (
              cartDrawer.hasAttribute('open') ||
              cartDrawer.classList.contains('active') ||
              cartDrawer.querySelector('details[open]')
            );

            if (isCartOpen) {
              checkAndRemoveSubscriptionFromCart(0, true);
            }
          } else {
            // Customer no longer has subscription, stop checking
            clearInterval(periodicCheckInterval);
          }
        }

        // Stop after 30 seconds (15 checks * 2 seconds)
        if (periodicCheckCount > 15) {
          clearInterval(periodicCheckInterval);
        }
      }, 2000);
    }

    // Listen for cart drawer opening - check immediately when cart opens
    const cartDrawerElement = document.querySelector('cart-drawer, .cart-drawer');
    if (cartDrawerElement) {
      // Watch for cart drawer opening
      const observer = new MutationObserver(function (mutations) {
        const isCartOpen = cartDrawerElement.hasAttribute('open') ||
          cartDrawerElement.classList.contains('active') ||
          cartDrawerElement.querySelector('details[open]');

        if (isCartOpen && window.customer) {
          const isSubscriptionCustomer = window.customer.tags &&
            window.customer.tags.some(tag => tag === 'Subscription' || tag.startsWith('Subscription-'));
          if (isSubscriptionCustomer) {
            // Check immediately, no delay
            checkAndRemoveSubscriptionFromCart(0, true);
            // Also check after 200ms as backup
            setTimeout(() => {
              checkAndRemoveSubscriptionFromCart(0, true);
            }, 200);
          }
        }
      });

      observer.observe(cartDrawerElement, {
        attributes: true,
        attributeFilter: ['open'],
        childList: true,
        subtree: true
      });

      // Also listen for cartdrawer:opened event
      document.addEventListener('cartdrawer:opened', function () {
        if (window.customer) {
          const isSubscriptionCustomer = window.customer.tags &&
            window.customer.tags.some(tag => tag === 'Subscription' || tag.startsWith('Subscription-'));
          if (isSubscriptionCustomer) {
            // Check immediately, no delay
            checkAndRemoveSubscriptionFromCart(0, true);
            // Also check after 200ms as backup
            setTimeout(() => {
              checkAndRemoveSubscriptionFromCart(0, true);
            }, 200);
          }
        }
      });
    }

    // Listen for cart:updated events - but only check if cart is already open
    let lastCartUpdateCheck = 0;
    document.addEventListener('cart:updated', function () {

      // On account pages, check and remove membership product if customer has subscription
      if (isLoginOrAccountPage()) {
        // If on account page (not login/register), check for membership product removal
        const isAccountPage = window.location.pathname.includes('/account') &&
          !window.location.pathname.includes('/account/login') &&
          !window.location.pathname.includes('/account/register');

        if (isAccountPage && window.customer) {
          const isSubscriptionCustomer = window.customer.tags &&
            window.customer.tags.some(tag => tag === 'Subscription' || tag.startsWith('Subscription-'));
          if (isSubscriptionCustomer) {
            checkAndRemoveSubscriptionFromCart(0, true);
          }
        } else {
          console.log('On login/register page, ignoring cart:updated event');
        }
        return;
      }

      // Only check if cart drawer is already open
      const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
      const isCartOpen = cartDrawer && (
        cartDrawer.hasAttribute('open') ||
        cartDrawer.classList.contains('active') ||
        cartDrawer.querySelector('details[open]')
      );

      if (!isCartOpen) {
        return;
      }

      // If cart is open and customer has subscription, check for membership product
      if (isCartOpen && window.customer) {
        const isSubscriptionCustomer = window.customer.tags &&
          window.customer.tags.some(tag => tag === 'Subscription' || tag.startsWith('Subscription-'));
        if (isSubscriptionCustomer) {
          checkAndRemoveSubscriptionFromCart(0, true);
        }
      }

      const now = Date.now();
      // Only check if at least 3 seconds have passed since last check
      if (now - lastCartUpdateCheck > 3000) {
        lastCartUpdateCheck = now;
        clearTimeout(window.subscriptionCheckTimeout);
        window.subscriptionCheckTimeout = setTimeout(() => {
          checkAndRemoveSubscriptionFromCart();
        }, 1000);
      }
    });
  } else {
    console.log('On login/account page - skipping all cart checks to prevent cart opening');
  }

  // Check if we're on the cart page and run check (cart page is always "open")
  if (window.location.pathname === '/cart' || window.location.pathname.includes('/cart')) {
    setTimeout(() => {
      checkAndRemoveSubscriptionFromCart(true); // forceCheck = true for cart page
    }, 1000);
  }

  // Also check when cart drawer opens (if it exists)
  const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      if (cartDrawer.hasAttribute('open') || cartDrawer.classList.contains('active')) {
        setTimeout(() => {
          checkAndRemoveSubscriptionFromCart();
        }, 500);
      }
    });
    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['open', 'class']
    });
  }
});

function openMembershipPopup() {
  const popup = document.getElementById('membership-popup');
  if (popup) popup.style.display = 'flex';
}

function closeMembershipPopup() {
  const popup = document.getElementById('membership-popup');
  if (popup) popup.style.display = 'none';
}

document.addEventListener('click', function (e) {
  if (e.target.id === 'membership-popup-close') {
    closeMembershipPopup();
  }
});